import { render, staticRenderFns } from "./Init.vue?vue&type=template&id=a0efdf6c"
import script from "./Init.vue?vue&type=script&lang=js"
export * from "./Init.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0efdf6c')) {
      api.createRecord('a0efdf6c', component.options)
    } else {
      api.reload('a0efdf6c', component.options)
    }
    module.hot.accept("./Init.vue?vue&type=template&id=a0efdf6c", function () {
      api.rerender('a0efdf6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Init.vue"
export default component.exports